window._paq = window._paq || [];
class StorageInterface {
  constructor() {
    if (this.constructor === StorageInterface) {
      throw new Error("Abstract class cannot be instantiated directly.");
    }
  }

  create(data) {
    throw new Error('Method "create" must be implemented.');
  }

  read(key) {
    throw new Error('Method "read" must be implemented.');
  }

  update(key, data) {
    throw new Error('Method "update" must be implemented.');
  }

  delete(key) {
    throw new Error('Method "delete" must be implemented.');
  }
}

class LocalStorage extends StorageInterface {
  create(data) {
    const cartItems = this.read(data.key);
    data.value.forEach((item) => {
      const index = cartItems?.findIndex((cartItem) => cartItem.id == item.id);
      if (index != -1) {
        cartItems.forEach((cartItem) => {
          if (cartItem.variant_id == item.variant_id) {
            cartItem.quantity += Number(item.quantity);
          }
        });
      } else {
        cartItems.push(item);
      }
    });
    localStorage.setItem(data.key, JSON.stringify(cartItems));
    return cartItems;
  }

  read(key) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : [];
  }

  update(data) {
    const localCart = this.read(data.key);
    for (const item of data.value) {
      const index = localCart?.findIndex((cartItem) => cartItem.id == item.id);
      if (index != -1) {
        localCart[index].quantity = item.quantity;
        localCart[index].checked = item.checked;
      } else {
        localCart.push({ ...item });
      }
    }
    localStorage.setItem(data.key, JSON.stringify(localCart));
    return localCart;
  }

  delete(data) {
    const localCart = this.read(data.key);
    for (const item of data.value) {
      const index = localCart?.findIndex((cartItem) => cartItem.id === item.id);
      if (index !== -1) {
        localCart.splice(index, 1);
      }
    }
    localStorage.setItem(data.key, JSON.stringify(localCart));
    return localCart;
  }

  clear(key) {
    localStorage.removeItem(key);
    return true;
  }
}

class Api extends StorageInterface {
  constructor() {
    super();
    this.readUrl = "api/v1/cart/list";
    this.cleanUrl = "api/v1/cart/clean";
    this.updateUrl = "api/v1/cart/batch-add";
    this.addUrl = "api/v1/cart/update";
    this.page = 1;
    this.size = 1000;
    this.updateController = null;
  }

  // 新增数据
  async create(data) {
    const list = await this.handleData(data.value);
    const params = {
      list,
      echo: true,
      page: this.page,
      size: this.size,
    };
    const responseData = await fetchRequest(this.addUrl, "POST", params);
    if (!responseData.error) {
      const total = responseData.data.total;
      if (total > 0) {
        const cartItems = this.updateInterfaceData(responseData);
        return cartItems;
      }
      return [];
    }
    return [];
  }
  //处理上报接口数据
  async handleData(data) {
    if (!data || data?.length == 0) return;
    for (let item of data) {
      item.quantity = Number(item.quantity);
      item.variant_id = String(item.variant_id);
    }
    return data;
  }

  // 读取数据
  async read(key) {
    const params = { page: this.page, size: this.size };
    const responseData = await fetchRequest(this.readUrl, "POST", params);
    if (!responseData.error) {
      const total = responseData.data.total;
      // if (total > this.page * this.size) {
      //   this.page++;
      //   this.getCartList();
      // }
      if (total > 0) {
        return this.updateInterfaceData(responseData);
      }
      return [];
    }
    return false;
  }

  // 接口购物车相关数据重组
  updateInterfaceData(responseData) {
    const interfaceList = [];
    interfaceList.push(...responseData.data.items);
    const productList = responseData.data.products;
    const variants = responseData.data.variants;
    for (let item of interfaceList) {
      const product = productList[item.product_id];
      const variant = variants[item.variant_id];
      const options = [];
      if (variant?.selected_options?.length > 0) {
        for (const option of variant?.selected_options) {
          options.push(option.value);
        }
      }
      item["id"] = item?.variant_id;
      item["product_title"] = product?.title;
      // item["url"] = `/products/${product?.handle}?variant=${item?.variant_id}`;
      item["url"] = `/products/${product?.handle}`;
      item["featured_image"] = { url: variant?.featured_image };
      item["final_price"] = variant?.price;
      item["final_line_price"] = variant?.price * item.quantity;
      item["variant_options"] = options;
      item["weight"] = variant?.weight;
      item["free_shipping"] = variant?.free_shipping;
    }
    // 由于数据每次返回顺序随机，使用变体Id进行排序
    const path = window.location.pathname;
    if (path.indexOf("/cart") != -1) {
      interfaceList.sort(
        (pre, next) => Number(next.variant_id) - Number(pre.variant_id)
      );
    }

    // 重组数据并返回
    return interfaceList;
  }

  // 更新数据
  async update(data) {
    if (this.updateController) {
      this.updateController.abort();
    }
    this.updateController = new AbortController();
    try {
      const config = {
        method: "POST",
        signal: this.updateController.signal,
        body: JSON.stringify({
          list: data.value,
          echo: true,
          page: this.page,
          size: this.size,
        }),
      };
      const params = {
        list: data.value,
        echo: true,
        page: this.page,
        size: this.size,
      };
      const responseData = await fetchRequest(this.updateUrl, "POST", params);
      if (!responseData.error) {
        const total = responseData.data.total;
        if (total > 0) {
          return this.updateInterfaceData(responseData);
        }
        return [];
      }
      return false;
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("请求被中断");
      } else {
        // console.error("请求出错:", error);
      }
    }
  }

  // 删除数据
  async delete(data) {
    const list = [];
    for (let item of data.value) {
      item.quantity = parseInt(0);
      list.push(item);
    }
    const params = {
      list,
      echo: true,
      page: this.page,
      size: this.size,
    };
    const responseData = await fetchRequest(this.updateUrl, "POST", params);
    if (!responseData.error) {
      const total = responseData.data.total;
      if (total > 0) {
        return this.updateInterfaceData(responseData);
      }
      return [];
    }
    return false;
  }

  // 清空数据
  async clear(key) {
    const responseData = await fetchRequest(this.cleanUrl, "POST");
    if (!responseData.error) return true;
    return false;
  }
}

class ShopifyRelatedV2 {
  constructor() {
    // 控制并发请求
    this.controllers = {
      create: null,
      read: null,
      update: null,
      delete: null,
      clear: null,
    };

    this.defaultData = {
      items: [],
      items_count: 0,
      total_price: 0,
      sub_total_price: 0,
      original_total_price: 0,
    };

    // 初始化购物车ID
    this.cartId = this.getCartId();
  }

  /**
   * 从localStorage获取购物车ID
   */
  getCartId() {
    return localStorage.getItem("shopify_cart_id") || null;
  }

  /**
   * 保存购物车ID到localStorage
   */
  saveCartId(cartId) {
    if (cartId) {
      localStorage.setItem("shopify_cart_id", cartId);
      this.cartId = cartId;
    }
  }

  mathCountry() {
    // 根据用户设置币种和国家计算shopify国家
    const jsonString = theme.getCookies("userSelected");
    const userSelected = theme.inspectJson(jsonString);
    const setCurrency = userSelected.currency_code ?? "USD"; // 用户设置币种
    const setCountry = userSelected.region_code ?? "US";
    const eurCountryList = ["DE", "ES", "FI", "FR", "GR", "IE", "IT"];
    let country = "";
    switch (setCurrency) {
      case "AED":
        country = "AE";
        break;
      case "AUD":
        country = "AU";
        break;
      case "CAD":
        country = "CA";
        break;
      case "CHF":
        country = "CH";
        break;
      case "CNY":
        country = "CN";
        break;
      case "DKK":
        country = "DK";
        break;
      case "EGP":
        country = "EG";
        break;
      case "EUR":
        country = eurCountryList.includes(setCountry) ? setCountry : "FR";
        break;
      case "GBP":
        country = "GB";
        break;
      case "ILS":
        country = "IL";
        break;
      case "INR":
        country = "IN";
        break;
      case "JPY":
        country = "JP";
        break;
      case "KRW":
        country = "KR";
        break;
      case "MXN":
        country = "MX";
        break;
      case "MYR":
        country = "MY";
        break;
      case "NZD":
        country = "NZ";
        break;
      case "PEN":
        country = "PE";
        break;
      case "PKR":
        country = "PK";
        break;
      case "PLN":
        country = "PL";
        break;
      case "QAR":
        country = "QA";
        break;
      case "SAR":
        country = "SA";
        break;
      case "SEK":
        country = "SE";
        break;
      case "SGD":
        country = "SG";
        break;
      case "THB":
        country = "TH";
        break;

      // case "ZAR":
      //   country = "ZA";
      // break;
      default:
        country = "US";
    }
    return country;
  }
  // 创建购物车并加入数据
  async create(items) {
    // 中止之前的请求
    if (this.controllers.create) {
      this.controllers.create.abort();
    }
    this.controllers.create = new AbortController();
    try {
      // 准备商品行数据
      const lines = items
        .filter((item) => item.checked)
        .map((item) => ({
          merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
          quantity: parseInt(item.quantity, 10),
        }));

      if (lines.length === 0) return this.defaultData;

      // GraphQL查询
      const query = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
              totalQuantity
              estimatedCost {
                checkoutChargeAmount {
                  currencyCode
                  amount
                }
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
              }
              discountAllocations {
                ... on CartCodeDiscountAllocation {
                  __typename
                  discountedAmount {
                    amount
                    currencyCode
                  }
                  targetType
                  code
                }
              }
              discountCodes {
                applicable
                code
              }
              lines(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    discountAllocations {
                      ... on CartAutomaticDiscountAllocation {
                        __typename
                        discountedAmount {
                          amount
                          currencyCode
                        }
                        targetType
                        title
                      }
                    }
                    estimatedCost {
                      amount {
                        amount
                        currencyCode
                      }
                      compareAtAmount {
                        amount
                        currencyCode
                      }
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        availableForSale
                        product {
                          id
                          title
                          handle
                          featuredImage {
                            url
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        input: {
          lines,
          buyerIdentity: { countryCode: this.mathCountry() },
        },
      };
      const data = await fetchGraphQL(query, variables);
      if (data.cartCreate.userErrors.length > 0) {
        throw new Error(data.cartCreate.userErrors[0].message);
      }

      // 保存购物车ID
      const cartId = data.cartCreate.cart.id;
      this.saveCartId(cartId);

      // 转换为与旧API兼容的格式
      const formattedCart = this.formatCartData(data.cartCreate.cart);

      // 上报添加到购物车事件
      this.reportAddCart(items.filter((item) => item.checked));

      return formattedCart;
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("请求被中断");
      } else {
        console.error("请求出错:", error);
      }
      return this.defaultData;
    }
  }

  /**
   * 读取购物车数据
   * @returns {Object} 购物车数据
   */
  // async read() {
  //   // 中止之前的请求
  //   if (this.controllers.read) {
  //     this.controllers.read.abort();
  //   }
  //   this.controllers.read = new AbortController();

  //   try {
  //     // 如果没有购物车ID，返回空购物车
  //     if (!this.cartId) {
  //       return { items: [], items_count: 0, total_price: 0 };
  //     }

  //     // GraphQL查询
  //     const query = `
  //       query getCart($cartId: ID!) {
  //         cart(id: $cartId) {
  //           checkoutUrl
  //           totalQuantity
  //           estimatedCost {
  //             checkoutChargeAmount {
  //               currencyCode
  //               amount
  //             }
  //             subtotalAmount {
  //               amount
  //               currencyCode
  //             }
  //             totalAmount {
  //               amount
  //               currencyCode
  //             }
  //           }
  //           discountAllocations {
  //             ... on CartCodeDiscountAllocation {
  //               __typename
  //               discountedAmount {
  //                 amount
  //                 currencyCode
  //               }
  //               targetType
  //               code
  //             }
  //           }
  //           discountCodes {
  //             applicable
  //             code
  //           }
  //           lines(first: 250) {
  //             edges {
  //               node {
  //                 id
  //                 quantity
  //                 discountAllocations {
  //                   ... on CartAutomaticDiscountAllocation {
  //                     __typename
  //                     discountedAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     targetType
  //                     title
  //                   }
  //                 }
  //                 estimatedCost {
  //                   amount {
  //                     amount
  //                     currencyCode
  //                   }
  //                   compareAtAmount {
  //                     amount
  //                     currencyCode
  //                   }
  //                   subtotalAmount {
  //                     amount
  //                     currencyCode
  //                   }
  //                   totalAmount {
  //                     amount
  //                     currencyCode
  //                   }
  //                 }
  //                 merchandise {
  //                   ... on ProductVariant {
  //                     id
  //                     title
  //                     availableForSale
  //                     product {
  //                       id
  //                       title
  //                       handle
  //                       featuredImage {
  //                         url
  //                         altText
  //                       }
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     `;

  //     const variables = {
  //       cartId: this.cartId,
  //     };

  //     const data = await fetchGraphQL(query, variables);

  //     // 如果购物车不存在，清除本地ID并返回空购物车
  //     if (!data.cart) {
  //       localStorage.removeItem("shopify_cart_id");
  //       this.cartId = null;
  //       return { items: [], items_count: 0, total_price: 0 };
  //     }

  //     // 转换为与旧API兼容的格式
  //     return this.formatCartData(data.cart);
  //   } catch (error) {
  //     if (error.name === "AbortError") {
  //       console.log("购物车读取请求被中断");
  //     } else {
  //       console.error("读取购物车失败:", error);
  //     }
  //     return { items: [], items_count: 0, total_price: 0 };
  //   }
  // }

  // /**
  //  * 更新购物车中的商品
  //  * @param {Array|Object} items - 要更新的商品
  //  * @returns {Object} 更新后的购物车数据
  //  */
  // async update(items) {
  //   // 中止之前的请求
  //   if (this.controllers.update) {
  //     this.controllers.update.abort();
  //   }
  //   this.controllers.update = new AbortController();

  //   try {
  //     // 如果没有购物车ID，先创建购物车
  //     if (!this.cartId) {
  //       return this.createCart(Array.isArray(items) ? items : [items]);
  //     }

  //     // 准备更新的行
  //     const lines = [];
  //     const itemsArray = Array.isArray(items) ? items : [items];

  //     for (const item of itemsArray) {
  //       // 如果商品被选中，更新数量；否则删除
  //       if (item.checked) {
  //         lines.push({
  //           id: item.cartLineId, // 需要购物车行ID
  //           quantity: parseInt(item.quantity, 10),
  //         });
  //       }
  //     }

  //     if (lines.length === 0) {
  //       // 如果没有要更新的行，可能是全部取消选中，调用删除方法
  //       return this.deleteItems(itemsArray);
  //     }

  //     // GraphQL查询
  //     const query = `
  //       mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  //         cartLinesUpdate(cartId: $cartId, lines: $lines) {
  //           cart {
  //             id
  //             checkoutUrl
  //             totalQuantity
  //             cost {
  //               totalAmount {
  //                 amount
  //                 currencyCode
  //               }
  //               subtotalAmount {
  //                 amount
  //                 currencyCode
  //               }
  //             }
  //             lines(first: 250) {
  //               edges {
  //                 node {
  //                   id
  //                   quantity
  //                   attributes {
  //                     key
  //                     value
  //                   }
  //                   estimatedCost {
  //                     amount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     compareAtAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     subtotalAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     totalAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                   }
  //                   merchandise {
  //                     ... on ProductVariant {
  //                       id
  //                       title
  //                       price {
  //                         amount
  //                         currencyCode
  //                       }
  //                       priceV2 {
  //                         amount
  //                         currencyCode
  //                       }
  //                       product {
  //                         id
  //                         title
  //                         handle
  //                         featuredImage {
  //                           url
  //                           altText
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //           userErrors {
  //             field
  //             message
  //           }
  //         }
  //       }
  //     `;

  //     const variables = {
  //       cartId: this.cartId,
  //       lines,
  //     };

  //     const data = await fetchGraphQL(query, variables);

  //     if (data.cartLinesUpdate.userErrors.length > 0) {
  //       throw new Error(data.cartLinesUpdate.userErrors[0].message);
  //     }

  //     // 转换为与旧API兼容的格式
  //     return this.formatCartData(data.cartLinesUpdate.cart);
  //   } catch (error) {
  //     if (error.name === "AbortError") {
  //       console.log("购物车更新请求被中断");
  //     } else {
  //       console.error("更新购物车失败:", error);
  //     }
  //     return null;
  //   }
  // }

  // /**
  //  * 从购物车中删除商品
  //  * @param {Array|Object} items - 要删除的商品
  //  * @returns {Object} 更新后的购物车数据
  //  */
  // async delete(items) {
  //   // 中止之前的请求
  //   if (this.controllers.delete) {
  //     this.controllers.delete.abort();
  //   }
  //   this.controllers.delete = new AbortController();

  //   try {
  //     // 如果没有购物车ID，返回空购物车
  //     if (!this.cartId) {
  //       return { items: [], items_count: 0, total_price: 0 };
  //     }

  //     // 准备要删除的行ID
  //     const lineIds = [];
  //     const itemsArray = Array.isArray(items) ? items : [items];

  //     for (const item of itemsArray) {
  //       if (item.cartLineId) {
  //         lineIds.push(item.cartLineId);
  //       }
  //     }

  //     if (lineIds.length === 0) {
  //       // 如果没有要删除的行，返回当前购物车
  //       return this.readCart();
  //     }

  //     // GraphQL查询
  //     const query = `
  //       mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  //         cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
  //           cart {
  //             id
  //             checkoutUrl
  //             totalQuantity
  //             cost {
  //               totalAmount {
  //                 amount
  //                 currencyCode
  //               }
  //               subtotalAmount {
  //                 amount
  //                 currencyCode
  //               }
  //             }
  //             lines(first: 250) {
  //               edges {
  //                 node {
  //                   id
  //                   quantity
  //                   attributes {
  //                     key
  //                     value
  //                   }
  //                   estimatedCost {
  //                     amount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     compareAtAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     subtotalAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                     totalAmount {
  //                       amount
  //                       currencyCode
  //                     }
  //                   }
  //                   merchandise {
  //                     ... on ProductVariant {
  //                       id
  //                       title
  //                       price {
  //                         amount
  //                         currencyCode
  //                       }
  //                       priceV2 {
  //                         amount
  //                         currencyCode
  //                       }
  //                       product {
  //                         id
  //                         title
  //                         handle
  //                         featuredImage {
  //                           url
  //                           altText
  //                         }
  //                       }
  //                     }
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //           userErrors {
  //             field
  //             message
  //           }
  //         }
  //       }
  //     `;

  //     const variables = {
  //       cartId: this.cartId,
  //       lineIds,
  //     };

  //     const data = await fetchGraphQL(query, variables);

  //     if (data.cartLinesRemove.userErrors.length > 0) {
  //       throw new Error(data.cartLinesRemove.userErrors[0].message);
  //     }

  //     // 上报删除购物车事件
  //     this.reportDeleteCart(itemsArray);

  //     // 转换为与旧API兼容的格式
  //     const formattedCart = this.formatCartData(data.cartLinesRemove.cart);

  //     // 更新购物车总价
  //     window._paq?.push([
  //       "trackEcommerceCartUpdate",
  //       Number(formattedCart.total_price),
  //     ]);

  //     return formattedCart;
  //   } catch (error) {
  //     if (error.name === "AbortError") {
  //       console.log("购物车删除请求被中断");
  //     } else {
  //       console.error("删除购物车商品失败:", error);
  //     }
  //     return null;
  //   }
  // }

  /**
   * 清空购物车
   * @returns {Boolean} 是否成功清空
   */
  async clear() {
    // 清空购物车事件上报
    window._paq?.push(["clearEcommerceCart"]);
    window._paq?.push(["trackEcommerceCartUpdate", 0]);
    return this.defaultData;
  }

  /**
   * 应用折扣码到购物车
   * @param {String} discountCode - 折扣码
   * @returns {Object} 更新后的购物车数据
   */
  async applyDiscountCode(discountCode) {
    try {
      // 如果没有购物车ID，返回错误
      if (!this.cartId) {
        throw new Error("购物车不存在");
      }

      // GraphQL查询
      const query = `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
              id
              checkoutUrl
              totalQuantity
              estimatedCost {
                checkoutChargeAmount {
                  currencyCode
                  amount
                }
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
              }
              discountAllocations {
                ... on CartCodeDiscountAllocation {
                  __typename
                  discountedAmount {
                    amount
                    currencyCode
                  }
                  targetType
                  code
                }
              }
              discountCodes {
                applicable
                code
              }
              lines(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    discountAllocations {
                      ... on CartAutomaticDiscountAllocation {
                        __typename
                        discountedAmount {
                          amount
                          currencyCode
                        }
                        targetType
                        title
                      }
                    }
                    estimatedCost {
                      amount {
                        amount
                        currencyCode
                      }
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        availableForSale
                        product {
                          id
                          title
                          handle
                          featuredImage {
                            url
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        cartId: this.cartId,
        discountCodes: [discountCode],
      };

      const data = await fetchGraphQL(query, variables);

      if (data.cartDiscountCodesUpdate.userErrors.length > 0) {
        throw new Error(data.cartDiscountCodesUpdate.userErrors[0].message);
      }

      return this.formatCartData(data.cartDiscountCodesUpdate.cart);
    } catch (error) {
      console.error("应用折扣码失败:", error);
      return this.defaultData;
    }
  }

  /**
   * 移除购物车中的折扣码
   * @returns {Object} 更新后的购物车数据
   */
  async removeDiscountCode() {
    try {
      // 如果没有购物车ID，返回错误
      if (!this.cartId) {
        throw new Error("购物车不存在，请先添加商品");
      }

      // GraphQL查询 - 传入空数组移除所有折扣码
      const query = `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
            cart {
              id
              checkoutUrl
              totalQuantity
              estimatedCost {
                checkoutChargeAmount {
                  currencyCode
                  amount
                }
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
              }
              discountAllocations {
                ... on CartCodeDiscountAllocation {
                  __typename
                  discountedAmount {
                    amount
                    currencyCode
                  }
                  targetType
                  code
                }
              }
              discountCodes {
                applicable
                code
              }
              lines(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    discountAllocations {
                      ... on CartAutomaticDiscountAllocation {
                        __typename
                        discountedAmount {
                          amount
                          currencyCode
                        }
                        targetType
                        title
                      }
                    }
                    estimatedCost {
                      amount {
                        amount
                        currencyCode
                      }
                      compareAtAmount {
                        amount
                        currencyCode
                      }
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                    }
                    merchandise {
                      ... on ProductVariant {
                        id
                        title
                        availableForSale
                        product {
                          id
                          title
                          handle
                          featuredImage {
                            url
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        cartId: this.cartId,
        discountCodes: [], // 空数组移除所有折扣码
      };

      const data = await fetchGraphQL(query, variables);

      if (data.cartDiscountCodesUpdate.userErrors.length > 0) {
        throw new Error(data.cartDiscountCodesUpdate.userErrors[0].message);
      }

      return this.formatCartData(data.cartDiscountCodesUpdate.cart);
    } catch (error) {
      console.error("移除折扣码失败:", error);
      return this.defaultData;
    }
  }

  /**
   * 将GraphQL购物车数据格式化为与旧API兼容的格式
   */
  formatCartData(cart) {
    if (!cart) return { items: [], items_count: 0, total_price: 0 };
    const autoDiscount = { amount: 0, title: "" };
    const items = cart.lines.edges.map((edge) => {
      const node = edge.node;
      const merchandise = node.merchandise;
      const estimatedCost = node.estimatedCost;
      const product = merchandise.product;
      const variantId = merchandise.id.split("/").pop();
      // 处理折扣信息
      const discounts =
        node.discountAllocations?.map((allocation) => {
          autoDiscount.amount = theme.add(
            Number(allocation.discountedAmount.amount || 0),
            Number(autoDiscount.amount)
          );
          autoDiscount.title = allocation?.title || allocation?.code || "";
          return {
            amount: allocation.discountedAmount.amount || 0,
            title: allocation?.title || allocation?.code || "",
          };
        }) || [];

      const final_price = theme.divide(
        Number(estimatedCost.totalAmount.amount),
        Number(node.quantity)
      );
      return {
        id: variantId,
        variant_id: variantId,
        cartLineId: node.id,
        product_id: product.id.split("/").pop(),
        product_title: product.title,
        variant_title: merchandise.title,
        quantity: node.quantity,
        original_price: estimatedCost.amount.amount,
        final_price,
        line_price: estimatedCost.subtotalAmount.amount,
        final_line_price: estimatedCost.totalAmount.amount,
        image: product.featuredImage?.url || "",
        handle: product.handle,
        properties: {},
        availableForSale: merchandise.availableForSale,
        discounts: discounts,
      };
    });
    const cartDiscounts =
      cart.discountAllocations?.map((allocation) => {
        return {
          amount: allocation.discountedAmount.amount,
          title: allocation?.code || allocation?.title || "",
        };
      }) || [];
    const originalTotalPrice = cart.estimatedCost.checkoutChargeAmount.amount;
    const totalPrice = cart.estimatedCost.totalAmount.amount;
    const subtotalPrice = cart.estimatedCost.subtotalAmount.amount;
    const totalDiscountAmount = cartDiscounts?.reduce(
      (sum, discount) => theme.add(sum, Number(discount?.amount)),
      0
    );

    // 获取应用的折扣码
    const discountCodes =
      cart.discountCodes
        ?.filter((code) => code.applicable)
        .map((code) => code.code) || [];
    const discountTotal = theme.add(totalDiscountAmount, autoDiscount.amount);
    return {
      token: cart.id.split("/").pop(),
      items,
      items_count: cart.totalQuantity,
      item_count: cart.totalQuantity,
      total_price: totalPrice,
      sub_total_price: subtotalPrice,
      original_total_price: originalTotalPrice,
      checkout_url: cart.checkoutUrl,
      discount_total: discountTotal,
      codeDiscount: {
        amount: totalDiscountAmount,
        title: discountCodes.join(", "),
      },
      autoDiscount,
    };
  }

  // 加购打点上报
  reportAddCart(list) {
    const typeStr = Object.prototype.toString.call(list);
    if (typeStr === "[object Array]") {
      for (let item of list) {
        window._paq.push([
          "addEcommerceItem",
          String(item.variant_id), //变体id
          item.product_title, // 产品标题
          "", // 产品分类,一个或多个用数组
          Number(item.final_price), // 价格
          Number(item.quantity), // 数量
        ]);
      }
    } else if (typeStr === "[object Object]") {
      if (list.checked) {
        window._paq.push([
          "addEcommerceItem",
          String(list.variant_id), //变体id
          list.product_title, // 产品标题
          "", // 产品分类,一个或多个用数组
          Number(list.final_price), // 价格
          Number(list.quantity), // 数量
        ]);
      }
    }
  }

  // 购物车删除打点上报
  reportDeleteCart(list) {
    const typeStr = Object.prototype.toString.call(list);
    if (typeStr === "[object Array]") {
      for (let item of list) {
        window._paq.push([
          "removeEcommerceItem",
          String(item.variant_id), //变体id
        ]);
      }
    } else if (typeStr === "[object Object]") {
      window._paq.push([
        "removeEcommerceItem",
        String(list.variant_id), //变体id
      ]);
    }
  }
}

class StorageAdapter {
  constructor() {
    // var userString = localStorage.getItem("user");
    const isLogin = theme.isLogin();
    this.storage = isLogin ? new Api() : new LocalStorage();
    this.maxNumber = 250;
  }

  handleData(data) {
    const list = data;
    const checkedCount = JSON.parse(
      sessionStorage.getItem("cartCount")
    )?.checkedCount;
    const gap = this.maxNumber - checkedCount;
    for (let i = 0; i < list.length; i++) {
      if (i < gap) {
        list[i].checked = true;
      } else {
        list[i].checked = false;
      }
    }
    return list;
  }
  async create(data) {
    // 加购时判断接口购物车数据是否超过250，若超过则提示，判断已勾选的购物车数量，若超过250，则超过的产品为未勾选状态
    const len = data.value.length;
    const count = JSON.parse(sessionStorage.getItem("cartCount"))?.count;
    if (len + count > this.maxNumber) {
      const reachedTips = document.querySelector("#reached-tips");
      reachedTips.classList.remove("hidden");
      data.value = this.handleData(data.value);
    }
    // 若未勾选的产品数量不超过250，则直接添加
    const list = await this.storage.create(data); // 购物车总数据
    this.storageCount(list);
    return list;
  }

  storageCount(data) {
    if (data?.length > 0) {
      let count = 0;
      let checkedCount = 0;
      for (let item of data) {
        count++;
        if (item.checked) {
          checkedCount++;
        }
      }
      sessionStorage.setItem(
        "cartCount",
        JSON.stringify({ checkedCount, count })
      );
    } else {
      sessionStorage.setItem(
        "cartCount",
        JSON.stringify({ checkedCount: 0, count: 0 })
      );
    }
  }

  async read(key) {
    const list = await this.storage.read(key);
    this.storageCount(list);
    return list;
  }

  update(data) {
    const typeStr = Object.prototype.toString.call(data.value);
    const list = [];
    if (typeStr === "[object Array]") {
      for (let item of data.value) {
        item.variant_id = String(item.variant_id);
        list.push(item);
      }
    } else if (typeStr === "[object Object]") {
      data.value.variant_id = String(data.value.variant_id);
      list.push(data.value);
    }
    data.value = list;
    return this.storage.update(data);
  }

  async delete(key) {
    const list = await this.storage.delete(key);
    this.storageCount(list);
    return list;
  }
  clear(key) {
    return this.storage.clear(key);
  }
}
